<script lang="ts">
  import Icon from '$components/elements/Icon.svelte';
  import FooterSection from '$components/footer/FooterSection.svelte';
  import Desktop from '$components/utils/Desktop.svelte';
  import Mobile from '$components/utils/Mobile.svelte';
  import { showCookiesPopup } from '$lib/stores';
  import type { LinkInterface } from '$types/interfaces';

  interface FooterSectionInterface {
    title: string;
    links: LinkInterface[][];
  }

  const footerSections: FooterSectionInterface[] = [
    {
      title: 'Bible21',
      links: [
        [
          {
            title: 'Bible online',
            url: '/online'
          },
          {
            title: 'O Bibli21',
            url: '/o-bibli21'
          },
          {
            title: 'Napsali o nás',
            url: '/ohlasy'
          }
        ],
        [
          {
            title: 'Nadační fond',
            url: '/nadacni-fond'
          },
          {
            title: 'Klub Bible21',
            url: '/klub-bible21'
          },
          {
            title: 'Kontakt',
            url: '/kontakt'
          }
        ]
      ]
    },
    {
      title: 'Sledujte nás',
      links: [
        [
          {
            title: 'Facebook',
            url: 'https://www.facebook.com/Bible21/',
            icon: 'facebook'
          }
        ]
      ]
    },
    {
      title: 'Příbuzné stránky',
      links: [
        [
          {
            title: 'Nakladatelství Biblion',
            url: 'https://www.biblion.cz/'
          },
          {
            title: 'Celonárodní čtení Bible',
            url: 'http://ctenibible.cz'
          }
        ]
      ]
    }
  ];

  const openCookies = () => showCookiesPopup.set(true);
</script>

<footer class="footer">
  <a
    class="footer__badge"
    href="https://greenpanda.cz?utm_source=client&utm_medium=badge&utm_campaign=bible21"
  >
    <div class="footer__badge__image">
      <svg
        width="51"
        height="29"
        viewBox="0 0 51 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M45.389 6.63049C44.7588 6.63049 44.0488 6.97893 43.6849 7.5974C43.5074 7.90228 43.3743 8.21587 43.3743 8.52075C43.3743 8.99985 43.6405 9.48765 44.1376 9.66187C44.7677 9.9232 45.4777 9.61832 45.9748 8.82563C46.241 8.39009 46.3742 7.98939 46.3742 7.5974C46.3742 6.98764 45.9748 6.63049 45.389 6.63049ZM22.029 19.5923C20.0143 20.1672 18.7185 20.6027 16.7925 20.7334C15.1329 20.8641 14.4228 20.7769 12.8963 20.6898C12.8963 20.6898 13.4377 18.6689 13.4377 17.04C13.4377 13.9215 11.5117 11.6828 8.60058 11.5086C7.57104 11.465 6.63025 11.6828 5.77821 12.127C3.98539 13.0504 3.08897 14.148 2.64521 14.5835C2.20144 15.0191 1.3494 15.8118 0.941136 15.3762C0.630498 15.0278 1.29615 13.8866 2.28131 12.1706C3.26648 10.411 5.01493 7.82388 7.07401 6.15139C10.2958 3.56426 15.4879 2.32732 20.3249 2.15311C20.3249 2.15311 21.6651 4.56601 22.2953 9.97546C22.4728 11.6044 22.5615 13.0504 22.5615 14.3222C22.5704 17.7456 22.029 19.5923 22.029 19.5923ZM35.8568 14.7577C35.8568 14.7577 35.8568 12.911 34.7385 11.0208C33.6203 9.0434 31.9605 8.20716 31.6499 6.05557C31.3836 4.33953 32.0493 2.36217 32.0493 2.36217C32.0493 2.36217 37.4633 2.7106 37.6852 2.75415C37.2858 4.68796 37.907 6.13397 39.1141 6.13397C40.0993 6.13397 40.2324 5.0364 40.5874 4.20016C40.8981 3.49458 41.2619 3.05903 41.7057 2.97192C43.4985 3.05903 44.8831 3.76461 46.0458 4.90574C47.5191 6.35174 47.1197 7.76291 47.386 9.33957C47.5635 10.3936 47.8741 11.2298 48.6817 12.4581C48.6817 12.4581 48.3711 12.8501 48.238 13.425C48.1048 14.087 48.2824 14.6096 48.2824 14.6096L46.7647 15.8379C44.6612 15.1759 42.4246 14.8274 40.0993 14.6532C38.8123 14.5835 37.1615 14.5835 35.8568 14.7577ZM49.4628 12.0835C48.877 11.1601 48.4332 9.97546 48.2557 9.00856C47.9451 7.37962 48.4332 6.2385 46.8268 4.44406C45.6197 3.12872 44.2796 2.46669 42.0341 2.16181C41.9897 0.93358 41.3152 0.0973416 40.3744 0.0102329C38.7147 -0.163984 38.0047 1.94404 38.0047 1.94404C38.0047 1.94404 32.502 1.55205 30.5316 1.41268C28.2506 1.28201 26.1028 1.19491 24.0881 1.19491C15.9849 1.1078 9.99401 2.68447 6.54149 5.49808C4.52678 7.12701 2.68958 9.71414 1.43815 11.8657C0.319858 13.8431 -0.576555 15.1584 0.452988 16.0818C1.12752 16.7003 2.15706 16.2124 2.64521 15.7333C3.13335 22.763 5.28119 29 7.20715 29H14.3696C14.3696 26.2299 11.3697 26.2735 11.5472 25.4024C11.7691 24.3484 12.7099 21.5348 12.7099 21.5348C13.5619 21.6219 14.414 21.6655 15.2127 21.6655C16.331 21.6655 17.3606 21.5783 18.257 21.4477C21.3456 20.9686 25.1531 19.2961 26.2714 19.2961C26.4933 19.2961 26.6265 19.3397 26.6265 19.5139C26.5821 19.7316 26.0851 22.5017 26.0851 24.9582C26.0851 27.0662 26.4401 29 27.7004 29H34.9959C34.9959 26.2299 32.0848 26.4564 32.3599 25.3502C32.7593 23.547 35.5817 18.0592 35.8036 15.6462C37.2325 15.4285 38.6703 15.472 40.0993 15.5591C42.469 15.6898 44.2618 16.0905 45.9659 16.526C46.4097 16.6567 46.9511 16.8309 47.3504 16.526L50.7497 13.7124C50.7675 13.7037 49.9598 12.8239 49.4628 12.0835Z"
          fill="#C99E77"
        />
      </svg>
    </div>

    <span>powered by<br />GreenPanda.cz</span>
  </a>
  <div class="footer__top">
    <a class="footer__top__link" href="/"><img src="/bible21--dark-gray.svg" alt="Bible21" /></a>
    <div class="footer__top__right">
      {#each footerSections as footerSection}
        <FooterSection title={footerSection.title} links={footerSection.links} />
      {/each}
    </div>
  </div>
  <hr class="footer__hr" />
  <div class="footer__bottom">
    <a href="/en" class="footer__bottom__language">
      <Icon icon="globe" /> English
    </a>
    <span on:click={openCookies} on:keypress={openCookies} class="footer__bottom__cookies">
      <Icon icon="cookie" /> Cookies
    </span>
    <hr class="footer__bottom__hr" />
    <div class="footer__bottom__copy">
      &copy; Bible21<Desktop>&nbsp;|&nbsp;</Desktop><Mobile><br /></Mobile>powered by
      <a href="https://greenpanda.cz" target="_blank">GreenPanda.cz</a>
    </div>
  </div>
</footer>

<style lang="scss">
  .footer {
    width: 100%;
    padding: 96px 0 70px;
    display: flex;
    flex-direction: column;
    gap: 40px;
    align-items: center;
    position: relative;
    background-color: $color-light-gray;
    &__badge {
      position: absolute;
      top: 96px;
      right: 0;
      height: 60px;
      border-radius: 30px 0 0 30px;
      border: 1.25px $color-caramel;
      border-style: solid none solid solid;
      display: flex;
      align-items: center;
      padding: 0 13px 0 12px;
      gap: 10px;
      background-color: $color-light-gray;
      overflow: hidden;
      transition: 0.2s ease all;
      &__image {
        width: 53px;
        display: block;
        svg {
          path {
            fill: $color-caramel;
          }
        }
      }
      span {
        font-size: 14px;
        font-weight: 700;
        color: $color-caramel;
        line-height: 120%;
      }
    }
    &__top,
    &__hr,
    &__bottom {
      width: 80%;
      max-width: 1280px;
    }
    &__top {
      display: flex;
      gap: 10%;
      margin-bottom: 40px;
      flex-wrap: wrap;
      padding-right: 50px;
      &__link {
        margin-right: auto;
      }
      &__right {
        display: flex;
        gap: 120px;
      }
    }
    hr {
      border: 0.5px solid rgba($color-dark-gray, 0.2);
    }
    &__bottom {
      display: flex;
      gap: 32px;
      &__language {
        display: flex;
        gap: 16px;
        align-items: center;
        font-size: 16px;
      }
      &__cookies {
        display: flex;
        cursor: pointer;
        gap: 16px;
        align-items: center;
        font-size: 16px;
      }
      &__hr {
        display: none;
      }
      &__copy {
        margin-left: auto;
        font-size: 16px;
        line-height: 23px;
        color: rgba($color-dark-gray, 0.5);
      }
    }
  }
  @media screen and (max-width: 1625px) {
    .footer {
      &__badge {
        width: 69px;
        &:hover {
          width: 195px;
        }
      }
    }
  }

  @media screen and (max-width: 1400px) {
    .footer {
      &__top {
        display: grid;
        &__link {
          grid-row: 1;
        }
        &__right {
          gap: 70px;
        }
      }
    }
  }
  @media screen and (max-width: 1000px) {
    .footer {
      gap: 30px;
      &__badge {
        top: 32px;
      }
      &__top {
        padding: 0;
        max-width: 412px;
        margin: 0 auto;
        gap: 30px;
        &__link {
          grid-row: 2;
          margin: 0 auto;
        }
        &__right {
          grid-row: 1;
          flex-direction: column;
          gap: 30px;
        }
      }
      &__top,
      &__hr,
      &__bottom {
        width: 90%;
      }
      &__hr {
        display: none;
      }
      &__bottom {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin: 10px 0 0;
        &__hr {
          display: block;
          width: 100%;
        }
        &__copy {
          text-align: right;
        }
      }
    }
  }
</style>
